import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqData = [
  {
    question: "How does the AI username generator work?",
    answer: "Our free AI username generator analyzes your interests, personality traits, and niche to create unique, creative usernames for Instagram, TikTok, YouTube, and other social media platforms. Choose from 12 theme styles including cool, funny, aesthetic, or professional to match your brand identity."
  },
  {
    question: "Is this username and bio generator really free?",
    answer: "Yes! NameBioLab is a completely free username generator and bio maker with unlimited uses. No signup required, no payment information needed, no hidden costs. Generate as many usernames and bios as you want for Instagram, TikTok, YouTube, Twitter, and more."
  },
  {
    question: "What platforms can I use these generated usernames for?",
    answer: "Our AI-generated usernames and bios work perfectly for all major social media platforms: Instagram username generator, TikTok username ideas, YouTube channel names, Twitter handles, Facebook usernames, LinkedIn profiles, Snapchat, Discord, gaming platforms (Steam, Xbox, PlayStation), and any other online platform."
  },
  {
    question: "How do I generate creative Instagram usernames?",
    answer: "To create the perfect Instagram username: 1) Describe your interests or brand in our username generator, 2) Select your preferred theme style (aesthetic, cool, funny, etc.), 3) Click generate to get 5 unique Instagram username ideas, 4) Copy your favorite and check availability on Instagram. Our AI creates memorable, catchy usernames optimized for social media."
  },
  {
    question: "Can I generate both usernames and bios together?",
    answer: "Absolutely! You can choose to generate: usernames only, bios only, or both together. Our AI bio generator creates compelling descriptions that match your username style, perfect for Instagram bios, TikTok profiles, YouTube about sections, and Twitter bios."
  },
  {
    question: "What if I don't like the generated username suggestions?",
    answer: "Simply click 'Generate Now' again for fresh username ideas! Try different theme styles (cool, aesthetic, funny, professional, quirky, minimalist, bold, vintage, modern, edgy, mysterious, or playful) or adjust your description for more personalized results. Unlimited free generations available."
  },
  {
    question: "Are the generated usernames unique and available?",
    answer: "Our AI creates unique username combinations, but availability depends on each platform. We recommend checking username availability on your target platform (Instagram, TikTok, YouTube, etc.) after generation. Generate multiple options to have backups if your first choice is taken."
  },
  {
    question: "How do I create an aesthetic Instagram username?",
    answer: "Select the 'Aesthetic' theme in our username generator and describe your style (e.g., 'minimalist fashion', 'vintage photography', 'soft aesthetic'). Our AI will generate beautiful, aesthetic usernames perfect for Instagram, complete with matching bio suggestions."
  }
];

const FAQ = () => {
  // Generate FAQ Schema for SEO
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqData.map(faq => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer
      }
    }))
  };

  return (
    <section className="w-full py-12 md:py-16 bg-accent/30" id="faq">
      {/* FAQ Schema Markup */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      
      <div className="container mx-auto px-4 md:px-6 max-w-4xl">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-4">
          Username Generator FAQ
        </h2>
        <p className="text-center text-muted-foreground mb-8 max-w-2xl mx-auto">
          Common questions about our free AI username and bio generator for Instagram, TikTok, YouTube, and social media
        </p>
        <Accordion type="single" collapsible className="w-full space-y-4">
          {faqData.map((faq, index) => (
            <AccordionItem key={index} value={`item-${index}`} className="bg-card rounded-lg px-6 border">
              <AccordionTrigger className="text-left font-semibold hover:no-underline">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
